export default __webpack_public_path__ + "static/media/angle-up-solid.1cb6a8cc.svg";